/**
 * 마크다운 ↔ HTML 변환 유틸리티
 * - Bold: **텍스트** ↔ <strong>텍스트</strong>
 */

/**
 * 마크다운 → HTML 변환
 * @param {string} text - 마크다운 텍스트
 * @returns {string} HTML 문자열
 */
export const markdownToHtml = (text) => {
  if (!text) return '';
  return text
    // [\s\S]*? 로 줄바꿈 포함 텍스트 처리
    .replace(/\*\*([\s\S]*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\n/g, '<br>');
};

/**
 * HTML → 마크다운 변환
 * @param {string} html - HTML 문자열
 * @returns {string} 마크다운 텍스트
 */
export const htmlToMarkdown = (html) => {
  if (!html || html === '<p><br></p>') return '';

  return html
    .replace(/<strong>([\s\S]*?)<\/strong>/gi, '**$1**')
    .replace(/<b>([\s\S]*?)<\/b>/gi, '**$1**')
    .replace(/<p><br><\/p>/gi, '\n')
    .replace(/<p>/gi, '')
    .replace(/<\/p>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/\n+$/, '')
    .trim();
};

/**
 * Bold 마크다운 렌더링 (표시용)
 * **텍스트** → <strong>텍스트</strong>
 * @param {string} text - 마크다운 텍스트
 * @returns {string} HTML 문자열 (dangerouslySetInnerHTML에 사용)
 */
export const renderBold = (text) => {
  if (!text) return '';
  // [\s\S]*? 로 줄바꿈 포함 텍스트 처리
  return text.replace(/\*\*([\s\S]*?)\*\*/g, '<strong>$1</strong>');
};
